var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "v-container",
    { staticClass: "fill-height", attrs: { fluid: "" } },
    [
      _c(
        "v-row",
        { attrs: { align: "center", justify: "center" } },
        [
          _c(
            "v-col",
            { attrs: { cols: "12", sm: "8", md: "6" } },
            [
              _c(
                "v-card",
                {
                  staticClass: "elevation-12",
                  attrs: { loading: _vm.loading },
                },
                [
                  _c("v-card-title", [_vm._v(" Авторизация ")]),
                  _vm.loading
                    ? _c(
                        "div",
                        { staticClass: "text-center ma-12" },
                        [
                          _c("v-progress-circular", {
                            attrs: {
                              indeterminate: "",
                              size: "70",
                              width: "2",
                              color: "dark",
                            },
                          }),
                        ],
                        1
                      )
                    : _c(
                        "v-card-text",
                        [
                          _vm._v(" Выберите способ авторизации "),
                          _c(
                            "a",
                            {
                              staticClass:
                                "my-2 v-btn v-btn--block v-btn--contained theme--dark v-size--default",
                              staticStyle: { background: "#4a76a8" },
                              attrs: { href: _vm.vk_url },
                            },
                            [
                              _c(
                                "v-icon",
                                {
                                  staticStyle: { color: "white" },
                                  attrs: { left: "", size: "25" },
                                },
                                [_vm._v(_vm._s(_vm.icon_vk))]
                              ),
                              _vm._v(" Вконтакте "),
                            ],
                            1
                          ),
                          _c(
                            "v-btn",
                            {
                              staticClass: "my-2",
                              attrs: { color: "#ee8208", dark: "", block: "" },
                              on: {
                                click: function ($event) {
                                  $event.stopPropagation()
                                  return _vm.getAuthCode("OK")
                                },
                              },
                            },
                            [
                              _c(
                                "v-icon",
                                { attrs: { left: "", size: "25" } },
                                [_vm._v(_vm._s(_vm.icon_ok))]
                              ),
                              _vm._v(" Одноклассники "),
                            ],
                            1
                          ),
                        ],
                        1
                      ),
                  _c("v-card-subtitle", [
                    _c("div", [
                      _vm._v(
                        " Для участии в закупках необходимо авторизоваться "
                      ),
                    ]),
                    _c("div", [
                      _c(
                        "a",
                        { attrs: { href: "#" }, on: { click: _vm.openVkWeb } },
                        [_vm._v("Сменить аккаунт в Вконтакте")]
                      ),
                    ]),
                  ]),
                ],
                1
              ),
            ],
            1
          ),
        ],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }